module.exports = __webpack_public_path__ + "static/img/cn.02c229de.svg";